"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReportsLayout = void 0;
var _objectSpread2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _react = _interopRequireDefault(require("react"));
var _reportsLayoutModule = _interopRequireDefault(require("./reports-layout.module.scss"));
var _useTranslation2 = require("../../hooks/useTranslation/useTranslation");
var _useCategories = _interopRequireDefault(require("./hooks/useCategories"));
var _UISettingsTabs = require("../../components/ui-settings-tabs/UISettingsTabs");
var ReportsLayout = function ReportsLayout(_ref) {
  var children = _ref.children,
    active = _ref.active;
  var _useTranslation = (0, _useTranslation2.useTranslation)(),
    t = _useTranslation.t;
  var categories = (0, _useCategories.default)();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h1", {
    className: _reportsLayoutModule.default['reports-layout__title']
  }, t('reportsLayout.title')), /*#__PURE__*/_react.default.createElement(_UISettingsTabs.UISettingsTabs, {
    className: _reportsLayoutModule.default['reports-layout__menu'],
    categories: categories.map(function (category) {
      return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, category), {}, {
        active: category.id === active
      });
    })
  }), children);
};
exports.ReportsLayout = ReportsLayout;